var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'absolute',
    'flex',
    'items-center',
    'justify-center',
    '-bottom-0.875',
    'right-0.875',
    'p-0.875',
    'rounded-full',
    'rounded-br-none',
    _vm.postColorClass ]},[_c('oz-button',{class:['rounded-full', _vm.buttonColorClass, _vm.buttonHoverColorClass, _vm.buttonIconColorClass],attrs:{"type":"custom","icon-size":16,"size":"small","icon-name":_vm.iconName,"color-scheme":"secondary"},on:{"click":function($event){return _vm.$emit('click', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }